import { render, staticRenderFns } from "./list-share-users-index.vue?vue&type=template&id=b83bf786&scoped=true&"
import script from "./list-share-users-index.vue?vue&type=script&lang=ts&"
export * from "./list-share-users-index.vue?vue&type=script&lang=ts&"
import style0 from "./list-share-users-index.vue?vue&type=style&index=0&id=b83bf786&lang=scss&scoped=true&"
import style1 from "./list-share-users-index.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83bf786",
  null
  
)

export default component.exports